<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <div class="vx-row no-gutter justify-center items-center">
                <img src="@/assets/images/logo/web-logo.png" alt="login" style="width:80%;"  class="mx-auto">
              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <!-- <h4 class="mb-4">{{ school_admin }}</h4> -->
                  <p>Welcome to {{ school_admin }}, please login to your account.</p>
                </div>
                <div class="mt-8 my-4">
                  <login-jwt></login-jwt>
                </div>

                <!-- <vs-tabs>
                  <vs-tab label="JWT">

                  </vs-tab>

                  <vs-tab label="Firebase">
                    <login-firebase></login-firebase>
                  </vs-tab>

                  <vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab>
                </vs-tabs> -->

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'
// import LoginFirebase from './LoginFirebase.vue'
// import LoginAuth0 from './LoginAuth0.vue'
import { EventBus } from '../messaging/mixin/EventBus'

export default {
  components: {
    LoginJwt
    // LoginFirebase,
    // LoginAuth0
  },
  data () {
    return {
      'school_admin' : ''
    }
  },
  mounted () {
    EventBus.$on('updateParent', (data) => {
      this.school_admin = data
    })
  },
  methods: {

  }


}
</script>

<style lang="scss">
.login-tabs-container {
  // min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
